import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-137">
          <div className="col-span-1 md:col-span-1" data-id="element-138">
            <div className="flex items-center gap-3 mb-4" data-id="element-139">
              <img src="https://cdn.magicpatterns.com/uploads/owR9nW8R3mfWdbuvzVE1p4/Logo_don_gian_O.png" alt="Lux Hair Logo" className="h-12 w-auto object-contain" data-id="element-140" />
              <div className="flex flex-col" data-id="element-141">
                <span className="text-xl font-bold leading-none text-white" data-id="element-142">
                  LUX HAIR
                </span>
                <span className="text-[10px] tracking-widest uppercase text-gray-400" data-id="element-143">
                  Vietnam Factory
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-6" data-id="element-144">
              Premium Vietnamese Hair Factory Supplying Wholesalers Worldwide —
              Built on Quality, Consistency, and Trust.
            </p>
            <div className="flex gap-4" data-id="element-145">
              <a href="https://www.facebook.com/profile.php?id=61578577686051&mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors" aria-label="Facebook" data-id="element-146">
                <Facebook className="w-5 h-5" data-id="element-147" />
              </a>
              <a href="https://www.instagram.com/lux_hair_vn.factory/" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors" aria-label="Instagram" data-id="element-148">
                <Instagram className="w-5 h-5" data-id="element-149" />
              </a>
              <a href="https://www.youtube.com/@Luxhairvietnamfactory" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors" aria-label="YouTube" data-id="element-150">
                <Youtube className="w-5 h-5" data-id="element-151" />
              </a>
              <a href="https://www.tiktok.com/@luxhairvnofficial" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors" aria-label="TikTok" data-id="element-152">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-153">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-154" />
                </svg>
              </a>
            </div>
          </div>

          <div data-id="element-155">
            <h4 className="text-white font-semibold mb-4" data-id="element-156">
              Lux Hair VN – Define Beauty
            </h4>
            <ul className="space-y-2 text-sm" data-id="element-157">
              <li data-id="element-158">
                <a href="#factory" className="hover:text-[#d4af37] transition-colors" data-id="element-159">
                  About Factory
                </a>
              </li>
              <li data-id="element-160">
                <a href="#collection" className="hover:text-[#d4af37] transition-colors" data-id="element-161">
                  Hair Collections
                </a>
              </li>
              <li data-id="element-162">
                <a href="#pricing" className="hover:text-[#d4af37] transition-colors" data-id="element-163">
                  Wholesale Pricing
                </a>
              </li>
              <li data-id="element-164">
                <a href="#contact" className="hover:text-[#d4af37] transition-colors" data-id="element-165">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-166">
            <h4 className="text-white font-semibold mb-4" data-id="element-167">Products</h4>
            <ul className="space-y-2 text-sm" data-id="element-168">
              <li data-id="element-169">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-170">
                  Bone Straight Hair
                </a>
              </li>
              <li data-id="element-171">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-172">
                  Raw Bulk Hair
                </a>
              </li>
              <li data-id="element-173">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-174">
                  Wavy & Curly
                </a>
              </li>
              <li data-id="element-175">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-176">
                  Closures & Frontals
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-177">
            <h4 className="text-white font-semibold mb-4" data-id="element-178">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-179">
              <li data-id="element-180">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-181">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-182">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-183">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-184">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-185">
                  Shipping Policy
                </a>
              </li>
              <li data-id="element-186">
                <a href="#" className="hover:text-[#d4af37] transition-colors" data-id="element-187">
                  Return Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500" data-id="element-188">
          <p data-id="element-189">
            &copy; {new Date().getFullYear()} Lux Hair Vietnam Factory. All
            rights reserved.
          </p>
          <p data-id="element-190">Designed for Wholesale Excellence.</p>
        </div>
      </div>
    </footer>;
}